import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

interface MenuType {
  id: number;
  name: string;
}

const fetchMenuTypes = async (): Promise<MenuType[]> => {
  try {
    const { data } = await api.get<MenuType[]>('/api/menu-types');
    return data;
  } catch (error) {
    console.error('Error en fetchMenuTypes:', error);
    if (error instanceof Error) {
      throw new Error(`Error al cargar los tipos de menú: ${error.message}`);
    }
    throw new Error('Error desconocido al cargar los tipos de menú');
  }
};

export const useMenuTypes = () => {
  const { 
    data: menuTypes = [], 
    isLoading, 
    error,
    isError 
  } = useQuery({
    queryKey: ['menu-types'],
    queryFn: fetchMenuTypes,
    retry: 1,
    refetchOnWindowFocus: false
  });

  return {
    menuTypes,
    isLoading,
    error: isError ? (error instanceof Error ? error.message : 'Error desconocido al cargar los tipos de menú') : null
  };
}; 